module.exports = __webpack_public_path__ + "img/1alB-y-yag.7a59ab89.jpg";